import React from 'react';



export const Network = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_wifi_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<g>
<path d="M18.6,12.9a9.39,9.39,0,0,0-13.29,0L4.07,11.62a11.15,11.15,0,0,1,15.77,0ZM12,14a5.5,5.5,0,0,1,3.92,1.62l1.24-1.25a7.3,7.3,0,0,0-10.33,0l1.24,1.24A5.51,5.51,0,0,1,12,14Zm0-7.75a13.18,13.18,0,0,1,9.38,3.89l1.23-1.24a15,15,0,0,0-21.25,0l1.25,1.24A13.18,13.18,0,0,1,12,6.26Zm-1.26,12A1.25,1.25,0,1,0,12,17,1.25,1.25,0,0,0,10.75,18.24Z"/>
</g>
</g>
</svg>
);
